<template>
  <div>
    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <!--begin::Form-->
        <b-form
          class="kt-form form elevation-1"
          @submit.stop.prevent="onSubmit"
        >
          <div class="div heading">
            <h2 class="form-heading">PAYNOWPRO</h2>
            <p>Forgot Password</p>
          </div>
          <b-form-group
            id="email-input-group"
            class="form-group"
            label
            label-for="email"
            ><label class="d1-block">Email Address</label>
            <b-form-input
              class="input"
              id="email-input"
              name="email"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="email-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="email-feedback"
              >A valid email address is required.</b-form-invalid-feedback
            >
          </b-form-group>
          <!--begin::Action-->
          <div class="kt-login__actions">
            <b-button
              id="kt_submit"
              type="submit"
              class="btn btn-auth login-btn-auth btn-primary btn-elevate kt-login__btn-primary kt-spinner--light kt-spinner--right"
              >Reset Password</b-button
            >
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Options-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
  </div>
</template>

<script>
import "./auth.css";
import AlertModal from "@/components/widgets/AlertModal.vue";
import { mapState } from "vuex";
import { Auth } from "aws-amplify";

import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  components: {
    AlertModal
  },
  data() {
    return {
      form: {
        email: null
      },
      alertModal: {
        show: false,
        text: "",
        type: AlertModal.INFORMATION
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name] ?? this.$v.confirm[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add("kt-spinner");

      // send register request
      Auth.forgotPassword(email)
        .then(data => {
          this.alert("Reset email sent", AlertModal.SUCCESS);
          submitButton.classList.remove("kt-spinner");
          this.$router.push({ name: "reset-password" });
        })
        .catch(err => {
          this.alert(err.message ?? err, AlertModal.ERROR);
          submitButton.classList.remove("kt-spinner");
        });
    },
    alert(text, type) {
      if (text) this.alertModal.text = text;
      if (type) this.alertModal.type = type;
      if (this.alertModal.text) this.alertModal.show = true;
    },
    resetAlert() {
      this.alertModal.text = "";
      this.alertModal.type = AlertModal.INFORMATION;
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    }
  }
};
</script>
